import React from 'react';
import styles from './IcomoonPreloader.module.scss';

export const IcomoonPreloader: React.FC = () => (
    <span className={styles.fontPreloader}>.</span>
);
